import React from "react";

class RadioOptionsInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value
        };
    }

    handleChange(value) {
        this.setState(
            {
                value: value
            },
            this.props.onChange.bind(null, value)
        );
    }

    render() {
        return (
            <fieldset>
                <span className={this.props.classes.radioList}>
                    {this.props.options.map(opt => (
                        <div key={opt.value} className={this.props.classes.radioListItem}>
                            <input
                                type="radio"
                                name={this.props.name}
                                id={opt.value}
                                aria-labelledby={this.props.labelId}
                                checked={this.state.value === opt.value}
                                className={this.props.classes.radio}
                                required={this.props.required ? "required" : undefined}
                                onChange={this.handleChange.bind(this, opt.value)}
                                onBlur={this.props.onBlur.bind(null, this.state.value)}
                            />
                            <label
                                className={this.props.classes.radioLabel}
                                id={this.props.labelId}
                                htmlFor={opt.value}
                            >
                                {opt.text}
                            </label>
                        </div>
                    ))}
                </span>
            </fieldset>
        );
    }
}

RadioOptionsInput.defaultProps = {
    classes: {},
    name: "",
    value: "",
    options: [],
    onChange: () => {},
    onBlur: () => {}
};

export default RadioOptionsInput;
